import styled from "styled-components";
import { NavLink } from "react-router-dom";

export const StyledLink = styled(NavLink)`
  display: flex;
  align-items: center;
  text-decoration: none;
  
  &.active {
    &:before {
      position: absolute;
      content: " ";
      top: 0;
      left: 0;
      bottom: 0;
      width: 0;
      border-right: 4px solid ${({ theme: { colors } }) => colors["sp-blue"]};
      border-radius: 0 4px 4px 0;
    }
  }
`;
